import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Label } from "reactstrap";
import Logo from '../Media/LogoLogin.png';
import PopUp from "Components/PopUp";
import BuildDetailsComponent from "../BuildDetails/BuildDetailsComponent";
import { Roles } from "shared/constants";
import { hasRole } from "utils/auth/authUtils";
import PackageJson from '../../package.json';


const Footer = () => {
  const [loadingPopUpBool, setLoadingPopUpBool] = useState(false);

  return (
    <React.Fragment>
      <footer className="footer p-0">
        <Container fluid={true}>
          <Row>
            <Col md={4} className="pos-start d-flex align-items-center">
              <Label className="mb-0">ecoSAIL © {PackageJson?.version} {new Date().getFullYear()}</Label>
              {hasRole(Roles.ES_ADMIN) &&
                <Label className='mb-0 link_color_blue'
                  onClick={() => setLoadingPopUpBool(true)}>
                  <span className="text-muted mb-0">&nbsp;|&nbsp;</span>Build
                </Label>
              }
              <PopUp
                state={loadingPopUpBool}
                setState={setLoadingPopUpBool}
                body={
                  <BuildDetailsComponent />
                }
                title={'Build Information'}
                size={'sm'}
              />
            </Col>
            <Col md={4}>
            </Col>
            <Col md={4} className="d-flex align-items-center justify-content-end">
              Developed by
              <Link
                to="https://ecosailinfotech.com/"
                className="ms-1 text-decoration-underline"
                target="_blank"
              >
                <img
                  src={Logo}
                  alt="Logo"
                  height={40}
                />
              </Link>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment >
  );
};

export default Footer;
